import { motion } from "framer-motion";

export const scrollToSection = (id) => {
  document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = ({ onOpenReader }) => {
  const links = [
    { label: "Capítulos", target: "#capitulos", testId: "nav-link-capitulos" },
    { label: "Frases", target: "#frases", testId: "nav-link-frases" },
    { label: "Autor", target: "#autor", testId: "nav-link-autor" },
  ];
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.4 }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0A0A0E]/70 border-b border-white/5"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 h-16 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="nav-logo"
          className="text-left"
        >
          <span className="font-display font-medium text-xs tracking-[0.3em] text-gold block uppercase">Edgar Merino Vidangossy</span>
          <span className="font-serif-book italic text-sm text-[#A19F9A]">Juega Tu Partido</span>
        </button>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.label}
              data-testid={l.testId}
              onClick={() => scrollToSection(l.target)}
              className="text-xs uppercase tracking-[0.25em] text-[#A19F9A] hover:text-[#F2EFE9] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-link-introduccion"
            onClick={onOpenReader}
            className="text-xs uppercase tracking-[0.25em] text-[#A19F9A] hover:text-[#F2EFE9] transition-colors duration-300"
          >
            Introducción
          </button>
        </nav>
        <button
          data-testid="nav-notify-button"
          onClick={() => scrollToSection("#newsletter")}
          className="text-xs uppercase tracking-[0.2em] px-5 py-2.5 border border-[#C5A059]/40 text-[#E2C08D] hover:bg-[#C5A059] hover:text-[#0A0A0E] transition-colors duration-300"
        >
          Avisarme
        </button>
      </div>
    </motion.header>
  );
};
